/** 军师历史话题的展示格式化(纯函数,可单测)。 */

/** ISO(后端 LocalDateTime,无时区=本地)→「M月D日 HH:mm」;坏输入返空串。 */
export function formatTopicDate(iso: string): string {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${d.getMonth() + 1}月${d.getDate()}日 ${hh}:${mi}`;
}

/** 话题标题:有则取标题;归档 sweep 尚未生成(null/空白)→ 退化「未命名话题 · 日期」。 */
export function topicTitleOf(t: { title: string | null; startedAt: string }): string {
  const title = t.title?.trim();
  return title || `未命名话题 · ${formatTopicDate(t.startedAt)}`;
}
